export const mapStatusFilter = (statusId, stageId) => {
  const index = stageId ? `${statusId}${stageId}` : statusId;
  const state =
    {
      0: "Todos",
      3: "Devolvido",
      6: "Waste",
      7: "A devolver",
      8: "Apagados",
      312: "NF/Reembolso",
      313: "Reposição"
    }[index] || "Todos";
  return state;
};
